<script>
  import OptionPanel from '../components/OptionPanel.svelte';
  import { editStore } from '../stores';
  import { t } from '../i18n';
</script>

<div class="option-area">
  {#if $editStore.selectedFeature}
    <OptionPanel />
  {:else}
    <div class="no-feature">{$t('selectFeature')}</div>
  {/if}
</div>

<style>
  .option-area {
    border-right: 1px solid #ccc;
    overflow-y: auto;
    /* height: 100%; */
  }
  .no-feature {
    padding: 1rem;
  }
  @media (max-width: 800px) { .option-area { grid-row: 3; border-right: 0; overflow: visible; } }
</style>